import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import es from 'vuetify/es5/locale/es';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
      dark: false,
      options: {
        customProperties: true,
      },
    themes: {
      light: {
        primary: colors.blue.darken3,   //blue-grey lighten-2,//'#01579B',//'#13367a',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
    },
  },
  lang: {
    locales: { es },
    current: 'es',
  },
  icons: {
    iconfont: ['fa','fab'],
    values:{
      error:"fa-exclamation-triangle",

      dropdown:"fa-angle-down",
      prev:"fa-angle-left",
      next:"fa-angle-right",

      expand:"fa-angle-down",
      subgroup:"fa-caret-down",

      delete:"fa-close",

      clear:"fa-times",
      file:"fa-paperclip",

      checkboxOff:"fa-square-o",
      checkboxOn:"fa-check-square ",
      checkboxIndeterminate:"fa-minus-square-o",

      dropdown:"fa-angle-down",
      prev:"fa-angle-left",
      next:"fa-angle-right",

      sort:"fa-caret-up", 

      last:"fa-angle-double-right",
      first:"fa-angle-double-left",

    }
  },
});

/*
      indeterminate-icon="fa fa-square-o"
      off-icon="fa fa-square-o"
      on-icon="fa fa-square-o"
*/ 